export const renderLoaderForForm = function(formElement) {

        formElement.addEventListener("submit", (event: any) => {

        let checkForValidations = document.querySelector(".field-validation-error");
        //to check all the required
        let numberOfValidTextFields = formElement.querySelectorAll(".required.text.valid");
        let numberOfRequiredTextFields = formElement.querySelectorAll(".required.text");
        
        if(numberOfValidTextFields !== null && numberOfRequiredTextFields !== null && numberOfValidTextFields.length === numberOfRequiredTextFields.length){
        
        if(window.getComputedStyle(checkForValidations).display === 'none')
        {
          let formSubmittedLoaderDiv = document.getElementById("formLoaderElement");
          formSubmittedLoaderDiv.style.display="block";

          let submitButton = document.querySelector(".submitButton");
          submitButton.setAttribute("disabled", "disabled"); 

        }
      }
      });
  };